import React from 'react';
import SettingsForm, { FieldDef } from './SettingsForm';
import platformSettingsService from '../../services/platformSettingsService';
import type { PlatformSettings } from '../../types';

const MONTHS = Array.from({ length: 12 }, (_, i) => ({ value: String(i + 1), label: new Date(2026, i, 1).toLocaleString('de-DE', { month: 'long' }) }));

export const DATEV_FIELDS: FieldDef[] = [
    { key: 'consultant_number', inputMode: 'numeric' },
    { key: 'client_number', inputMode: 'numeric' },
    { key: 'chart_of_accounts', select: [{ value: 'SKR03', label: 'SKR03' }, { value: 'SKR04', label: 'SKR04' }] },
    { key: 'account_length', inputMode: 'numeric' },
    { key: 'fiscal_year_start_month', select: MONTHS },
];

/** DATEV-Export (EXTF-Header): Berater-/Mandantennummer, Kontenrahmen, Sachkontenlänge, Wirtschaftsjahr. */
const DatevTab: React.FC<{ data: PlatformSettings; onChange: (s: PlatformSettings) => void }> = ({ data, onChange }) => (
    <SettingsForm
        group="datev"
        labelPrefix="platformSettings.datev"
        defs={DATEV_FIELDS}
        data={data.datev}
        onSave={async (values) => onChange(await platformSettingsService.update({ datev: values }))}
    />
);

export default DatevTab;
